import State from './state'

function show(show: boolean) {
  const el = State.refs.preloaderEl
  if (!el) return
  el.classList.toggle('hidden', !show)
}

export default { show }
